export default __webpack_public_path__ + "static/media/Email.792ef22f.png";